import { render, staticRenderFns } from "./coach-list-table.vue?vue&type=template&id=70246f52&"
import script from "./coach-list-table.vue?vue&type=script&lang=js&"
export * from "./coach-list-table.vue?vue&type=script&lang=js&"
import style0 from "./coach-list-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports